import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IBasicParameterFormMeta {
    prePaidProgram: FormInputMeta;
    initialChargeAmount: FormInputMeta;
    initialChargeFees: FormInputMeta;
    statementOfFees: FormInputMeta;

}

const basicParameterFormMeta = {} as IBasicParameterFormMeta;

basicParameterFormMeta.prePaidProgram = {
    name: "prePaidProgram",
    type: "select",
    label: "Programme Pré-Paid",
    placeholder: "",
    validation: yup.string(),
};

basicParameterFormMeta.statementOfFees = {
    name: "statementOfFees",
    type: "text",
    label: "Relevé Frais",
    placeholder: "",
    validation: yup.string(),
};

basicParameterFormMeta.initialChargeAmount = {
    name: "initialChargeAmount",
    type: "text",
    label: "Montant Charge Initiale",
    placeholder: "",
    validation: yup.string(),
};

basicParameterFormMeta.initialChargeFees = {
    name: "initialChargeFees",
    type: "select",
    label: "Frais Charge Initiale",
    placeholder: "",
    validation: yup.string(),
};

export default basicParameterFormMeta;